export default function CopyToClipboard({ text }) {
  const handleCopy = () => {
    navigator.clipboard.writeText(text)
      .then(() => {
        alert('Teksten er kopieret til clipboard!');
      })
      .catch(err => {
        console.error('Fejl ved kopiering:', err);
      });
  };

  return (
    <p 
      style={{ cursor: 'pointer' }} 
      onClick={handleCopy}
    >
      {text}
    </p>
  );
};